export default __webpack_public_path__ + "static/media/323.e22bc439.png";